import { render, staticRenderFns } from "./LedesType.vue?vue&type=template&id=c32b1b80&"
import script from "./LedesType.vue?vue&type=script&lang=js&"
export * from "./LedesType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports